













































































import Vue from 'vue';
import DataSourceList from './dataSourceList.vue';
import { mapState, mapMutations } from 'vuex';
import { mapDataSource } from './utils/mapDataSource';
import { DataSource, ValueType,  booleanType } from './types/interface';

export default Vue.extend({
    data() {
        return {
            staticDS: DataSource.Static,
            pointDS: DataSource.Point,
            real: ValueType.Real,
            history: ValueType.History,

            options: [{
                value: String(DataSource.Static),
                label: '静态数据'
            }, {
                value: String(DataSource.Point),
                label: '测点配置'
            }],

            // valueType: '',
            valueTypeOptions: [{
                value: String(ValueType.Real),
                label: '实时值'
            }, {
                value: String(ValueType.History),
                label: '历史值'
            }],

            startDate: '',
            endDate: '',

            disDataSourceBtn: false,
            // reqMethod: '1',
        }
    },
    computed: {
        ...mapState({
            partSelection: (state: any) => state.screen.editor.partSelection,
            dataSource: (state: any) => state.screen.editor.dataSource,
        }),
        ...mapDataSource({
            sourceType: {
                // 需要从哪个对象上获取自身的属性
                carrier: 'partData',
                // 设置自身属性的简单适配器
                getOption: (newValue: number) => {
                    return {
                        sourceType: newValue,
                    }
                },
                default: -1
            },
            valueType: {
                carrier: 'pointData',
                getOption: (newValue) => {
                    return {
                        valueType: newValue,
                        mode: 'pointData',
                    }
                },
                default: 1,
            },
        }),
        sourceTypeString: {
            get(): string {
                return String(this.sourceType);
            },
            set(sourceType): void {
                this.sourceType = Number(sourceType);
            }
        },
        valueTypeString: {
            get(): string {
                return String(this.valueType);
            },
            set(valueType): void {
                this.valueType = Number(valueType);
            }
        },
        /**
         * 被选中的part数组
         */
        selectGroup(): Model.Part[] {
            return this.partSelection.selectGroup
        },
        /**
         * 当前选中的part
         * 目前只处理单个part
         */
        curSelectPart(): Model.Part {
            const { length } = this.selectGroup
            return length === 1 ? this.selectGroup[0] : {}
        },
        /**
         * 优化选中part的性能
         * 修改为释放part，才更新配置项 -- 样式 or 数据
         */
        isReleasePart(): boolean {
            return this.partSelection.releasePart;
        },
        partData(): any {
            const partData = this.curSelectPart.partData;
            return partData;
        },
        pointData() {
            const pointData =  (this.partData && this.partData.pointData) || {};
            return pointData;
        },
        sourceTypeBtn(): boolean {
            let disable: boolean = false;
            const isPoint: booleanType = () => {
                return (this as any).sourceType === this.pointDS && (this as any).valueType;
            }
            const isStatic: booleanType = () => {
                return (this as any).sourceType === this.staticDS;
            }
            const isPointHistory: booleanType = () => {
                return (this as any).valueType === this.history
                    && Boolean(this.startDate)
                    && Boolean(this.endDate);
            }
            const isPointReal: booleanType = () => {
                return (this as any).valueType === this.real;
            }
            
            // 如果是测点，必须填取值类型
            if (isPoint()) {
                // 取值类型为历史，必须填时间
                if (isPointHistory()) {
                    disable = false;
                // 取值类型为实时
                } else if (isPointReal()) {
                    disable = false;
                } else {
                    disable = true;
                }
            // 取值类型为静态数据
            } else if (isStatic()) {
                disable = false;
            } else {
                disable = true;
            }
            return disable;
        },
        drawerTitle() {
            let label = '配置数据源';
            if (this.sourceType === this.staticDS) {
                label = '静态数据' + label;
            } else if (this.sourceType === this.pointDS) {
                label = '测点数据' + label;
            }
            return label;
        },
        drawerStatus: {
            get(): boolean {
                return this.dataSource.drawerStatus;
            },
            set(newDrawerStatus: boolean) {
                this.set_drawerStatus(newDrawerStatus);
            }
        }
    },
    watch: {
        /**
         * 监听当前选中的part
         */
        curSelectPart() {
            this.initSourceType();
        },
        startDate(newValue: string) {
            const option = {
                dateRange: [this.startDate, this.endDate],
                mode: 'pointData',
            };
            this.set_partData(option);
        },
        endDate() {
            const option = {
                dateRange: [this.startDate, this.endDate],
                mode: 'pointData',
            };
            this.set_partData(option);
        },
    },
    components: {
        DataSourceList
    },
    methods: {
        ...mapMutations([
            'set_partData',
            'set_drawerStatus',
        ]),
        /**
         * 数据源改变
         * 更新展示数据
         */
        sourceTypeChange() {
            (this.$root as any).busRef.$emit('scriptChange');
        },
        /**
         * 打开数据源配置
         */
        dataSourceCfg() {
            this.drawerStatus = true;
        },
        /**
         * 初始化sourceType为静态数据
         */
        initSourceType(): void {
            if (this.sourceType === -1) {
                this.sourceTypeString = this.staticDS;
            }
        },
        /**
         * Fixed me，这是一个hack
         * 为了让drawer里面的组件mouted就能渲染...
         * 因为drawer里面用了section模块v-if，并不渲染组件
         */
        renderDrawerComponent(isDestroyed?: boolean) {
            if (isDestroyed) {
                if (this.$refs && this.$refs.elDrawer) {
                    this.$refs.elDrawer = null;
                }
            };
            if (this.$refs.elDrawer) {
                this.$refs.elDrawer.rendered = true;
            }
        }
    },
    mounted() {
        this.renderDrawerComponent();
    },
    beforeDestroy() {
        this.renderDrawerComponent(true);
    }
})
